module.exports = __webpack_public_path__ + "img/symbol_11.b640ec47.png";